import DestinationAccount, { DestinationAccountResponse } from "./destinationAccount";
import SourceAccount, { SourceAccountResponse } from "./sourceAccount";

export enum NewTransferStatusType {
  WAIT_FOR_IRA_OPENING = "WAIT_FOR_IRA_OPENING",
  IRA_OPENING_ERROR = "IRA_OPENING_ERROR",
  PENDING_DESTINATION = "PENDING_DESTINATION",
  PENDING_ROTH_DESTINATION = "PENDING_ROTH_DESTINATION",
  PENDING_TRAD_DESTINATION = "PENDING_TRAD_DESTINATION",
  SCHEDULE_PHONE_CALL = "SCHEDULE_PHONE_CALL",
  PROCESSING = "PROCESSING",
  ADDITIONAL_INFORMATION_NEEDED = "ADDITIONAL_INFORMATION_NEEDED",
  INITIATED_AT_SOURCE = "INITIATED_AT_SOURCE",
  CHECK_SENT_TO_DESTINATION = "CHECK_SENT_TO_DESTINATION",
  COMPLETE = "COMPLETE",
  CANCELLED = "CANCELLED",
}

export type TransferInstruction = {
  transferInstructionId: number;
  transferInstructionStatus: NewTransferStatusType;
  transferExternalStatusDescription: string;
  transferExternalStatus: string;
  scheduledPhoneCall: null | string;
  source: SourceAccountResponse | SourceAccount;
  destinations: DestinationAccountResponse[] | DestinationAccount[];
  transferId: number;
};
